import { render, staticRenderFns } from "./pcFooterComponent.vue?vue&type=template&id=7470c9d7&scoped=true"
import script from "./pcFooterComponent.vue?vue&type=script&lang=js"
export * from "./pcFooterComponent.vue?vue&type=script&lang=js"
import style0 from "./pcFooterComponent.vue?vue&type=style&index=0&id=7470c9d7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7470c9d7",
  null
  
)

export default component.exports